import { createApi } from '@reduxjs/toolkit/query/react';
import type { Account } from './models/account.model';
import BaseQuery from './base.api';


export const accountsApi = createApi({
    reducerPath: 'accountsApi',
    baseQuery: BaseQuery('/v1/accounts'),
    tagTypes: ['Account'],
    endpoints: (builder) => ({
        getAccounts: builder.query<Account[], string | undefined>({
            query: (searchValue) => {
							if (searchValue) {
								return `?searchValue=${encodeURIComponent(searchValue)}`;
							}
							return '';
            },
            providesTags: ['Account'],
        }),
    }),
});

export const { useGetAccountsQuery } = accountsApi;
